(() => {
  function formatViews(n) {
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    return String(n);
  }

  async function postAction(action, handle) {
    const res = await fetch('/apps/champkoi', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, product_handle: handle }),
    });
    return res.json();
  }

  async function init() {
    const el = document.getElementById('product-view-count');
    if (!el) return;

    const handle = el.dataset.productHandle;
    if (!handle) return;

    try {
      const sessionKey = 'ck_viewed_' + handle;
      // Local theme dev (localhost) reads the count but never adds a view: testing used to
      // inflate the public "N views" on real koi (theme.liquid skips analytics there the same way)
      const localDev = /^(localhost|127\.0\.0\.1|\[::1\])$|\.localhost$/.test(location.hostname);
      const alreadyViewed = localDev || sessionStorage.getItem(sessionKey);

      const countEl = el.querySelector('.product-views__count');
      let views;

      if (!alreadyViewed) {
        sessionStorage.setItem(sessionKey, '1');
        const data = await postAction('track-view', handle);
        if (!data.success || !data.views) return;
        views = data.views;
        sessionStorage.setItem(sessionKey + '_views', String(views));
      } else {
        const cached = sessionStorage.getItem(sessionKey + '_views');
        if (cached) {
          views = parseInt(cached, 10);
        } else {
          const data = await postAction('get-view-count', handle);
          if (!data.success || !data.views) return;
          views = data.views;
          sessionStorage.setItem(sessionKey + '_views', String(views));
        }
      }

      countEl.textContent = formatViews(views) + (views === 1 ? ' view' : ' views');
      el.hidden = false;
    } catch {
      // Silently fail — view count is non-critical
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
